// extracted by css-extract-rspack-plugin
export default {"MainWrapper":"Layout_MainWrapper__8rzc7"};